import type { MediaAsset } from '@entities/media'

const deletionBlockedStates = new Set<MediaAsset['state']>([
	'UPLOADING',
	'PROCESSING',
	'DELETING',
	'DELETED',
])

export const canMarkMediaForDeletion = (
	asset: Pick<MediaAsset, 'state' | 'reference_count'>,
	allowed: boolean,
) => allowed && (asset.reference_count ?? 0) === 0 && !deletionBlockedStates.has(asset.state)
